import { Text as KonvaText } from "react-konva"
import { Transform } from "../../../../geometry/transformation"
import { useEffect } from "react";

const TextBase = (
  { setRef, shapeProps, onClick, interaction }: BaseShapeProps<TextShape>
) => {

  // const dispatch = useAppDispatch();
  // const konvaShape = useRef<Text>(null);
  const transform = new Transform(shapeProps.transformation);
  const position = transform.point2d({ x: shapeProps.x, y: shapeProps.y })

  const { width, height, ...newProps } = {
    ...shapeProps,
    x: position.x,
    y: -position.y,
    text: shapeProps.uiText,
    rotation: -transform.getRotation() * 180 / Math.PI,
    id: shapeProps.id.toString(),
    fill: shapeProps.lineColor,
  }

  useEffect(() => {
    // const heightFromKonva: number = konvaShape.current?.getHeight();
    // const widthFromKonva: number = konvaShape.current?.getWidth();
    //dispatch(replaceShape({ ...shapeProps, width: widthFromKonva ?? 0, height: heightFromKonva ?? 0 }))
  }, [shapeProps.uiText, shapeProps.fontStyle, shapeProps.fontStyle, shapeProps.fontSize])

  return (
    <KonvaText
      dragBoundFunc={function (this, pos) {
        return this._lastPos || this.absolutePosition();
      }}
      ref={setRef}
      onDragStart={interaction?.handleDragStart}
      onDragMove={interaction?.handleDragMove}
      onDragEnd={interaction?.handleDragEnd}
      onClick={onClick}
      {...newProps}
    />
  )
}
const createTextBase = (shape: GeometricShape) => {
  return (
    <TextBase shapeProps={shape as TextShape} />
  )
}

export { createTextBase };
export default TextBase;